import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';
import { isEqual } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import InviteStudentsRow from '../components/InviteStudentsRow';
import { blankStudent, perPage } from '../constants/inviteStudentsDefaults';
import InviteStudentsContainer from '../InviteStudentsContainer';
import { StyledPagination } from '../styles/styled-components';

const InviteErrors = () => {
    const { t } = useTranslation('invite_students');

    const {
        canSubmit,
        alerts,
        setAlerts,
        students,
        setStudents,
        errorIndexes,
        setErrors,
        handleStudentChange,
        isDuplicateEmail,
        isDuplicateExtUserId
    } = useContainer(InviteStudentsContainer);
    const [currentPage, setCurrentPage] = useState(1);

    const numberOfErrors = errorIndexes.length;
    const numberOfPages = Math.ceil(numberOfErrors / perPage);

    useEffect(() => {
        setErrors(students);
        // Remove validation error alerts when naviating to the naviagtion tab
        setAlerts(alerts.filter((alert) => !(alert.category === 'validationError')));
        // eslint-disable-next-line
    }, []);

    const removeRow = (index: number) => {
        const copyOfStudents = [...students];
        copyOfStudents.splice(index, 1);
        setStudents(copyOfStudents);
        setErrors(copyOfStudents);
    };

    const renderRows = () => {
        if (errorIndexes.length === 0 || (students.length === 1 && isEqual(students[0], blankStudent))) {
            return <Typography>{t('error-mode.no-errors')}</Typography>;
        }

        // To reduce computational overhead with very large data we compose a set of paginated indexes from which to render the student rows
        const paginatedIndexes: number[] = [];
        let currentIndex = (currentPage - 1) * perPage;

        while (paginatedIndexes.length < perPage && currentIndex < numberOfErrors) {
            paginatedIndexes.push(errorIndexes[currentIndex]);
            currentIndex += 1;
        }

        return paginatedIndexes.map((studentIndex) => (
            <InviteStudentsRow
                key={studentIndex}
                index={studentIndex}
                student={students[studentIndex]}
                addRow={() => {}}
                removeRow={removeRow}
                handleChange={handleStudentChange}
                lastRow={false}
                canSubmit={canSubmit}
                showErrors={true}
                isDuplicateEmail={isDuplicateEmail(studentIndex)}
                isDuplicateExtUserId={isDuplicateExtUserId(studentIndex)}
            />
        ));
    };

    const renderPaginator = () => {
        if (numberOfPages > 1) {
            return (
                <StyledPagination
                    count={numberOfPages}
                    page={currentPage}
                    color="primary"
                    onChange={(event, page) => {
                        if (page !== null && page !== undefined) setCurrentPage(page);
                    }}
                />
            );
        }

        return null;
    };

    return (
        <>
            {renderRows()}
            {renderPaginator()}
        </>
    );
};

export default InviteErrors;
